module.exports = __webpack_public_path__ + "assets/media/msg-type.44b62c1b.mp3";